import * as ActionTypes from '../../actions/allActions'
import { normalizeTimeSlots } from "../../normalizers/bookingFlowNormalizers"
import { normalizeResidence } from "../../normalizers/residenceNormalizer"
import { affiliateNormalizer } from "../../normalizers/Normalizers";

const bookingFlowInit = {
	frequency: 0,
	bookingServices: [],
	timeSlots: {},
	voucherType: '',
	sodexoRegion: '',
	sodexoNumber: '',
	bedroomsCount: 1,
	bathroomsCount: 1,
	selectedTimeSlot: undefined,
	selectedHourTimeSlots: undefined,
	duration: 3
}
const bookingFlow = (state = bookingFlowInit, action) => {
	switch (action.type) {
		case ActionTypes.BOOKINGFLOW_START:
			return bookingFlowInit
		case ActionTypes.BOOKINGFLOW_DATACHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.BOOKING_FLOW_FIND_AFFILIATE_SUCCESS:
			return { ...state, selectedAffiliate: affiliateNormalizer(action.data.data) }
		case ActionTypes.BOOKING_FLOW_CHECK_ZIP_CODE_SUCCESS:
			if (action.data.covered) {
				return { ...state, zipCode: action.requestMeta.zipCode }
			}
			return state
		case ActionTypes.BOOKING_FLOW_FETCH_WORKER_LANGUAGES_SUCCESS:
			return { ...state, workerLanguages: action.data.data }
		case ActionTypes.BOOKING_FLOW_FETCH_AFFILIATES_SUCCESS:
			return { ...state, affiliates: action.data.data }
		case ActionTypes.BOOKING_FLOW_FETCH_WORKERS_SUCCESS:
			return { ...state, workers: action.data.data }
		case ActionTypes.BOOKING_FLOW_TOGGLE_BOOKING_SERVICE:
			let bookingServiceId = action.bookingServiceId
			let bookingServices = [...state.bookingServices]
			if (bookingServices.includes(bookingServiceId)) {
				let index = bookingServices.indexOf(bookingServiceId);
				bookingServices.splice(index, 1)
			} else {
				bookingServices.push(bookingServiceId)
			}
			return { ...state, bookingServices: bookingServices }
		case ActionTypes.BOOKING_FLOW_FETCH_TIME_SLOTS_REQUEST:
			return { ...state, selectedTimeSlot: undefined, selectedHourTimeSlots: undefined }
		case ActionTypes.BOOKING_FLOW_FETCH_TIME_SLOTS_SUCCESS:
			return { ...state, timeSlots: { ...state.timeSlots, ...normalizeTimeSlots(action.data.data, action.data.labels) } }
		case ActionTypes.CREATE_RESIDENCE_SUCCESS:
			return { ...state, selectedSodexoResidence: normalizeResidence(action.data.data) }
		case ActionTypes.LOGOUT:
			return bookingFlowInit
		default:
			return state
	}
}

export default bookingFlow


// WEBPACK FOOTER //
// ./src/reducers/data/bookingFlow.js